module.exports = __webpack_public_path__ + "media/images/logo-lakms-975447f83fde6823af93e87333f121a5.png";